export const NATIONAL_INSURANCE_NUMBER_STEP = 'NATIONAL_INSURANCE_NUMBER';
export const SIGNATURE_STEP = 'SIGNATURE';
export const AUTHORISATION_STEP = 'AUTHORISATION';
export const THANK_YOU_STEP = 'THANK_YOU';
